import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Car, User } from 'lucide-react';

const LaunchOfferModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const isClosed = sessionStorage.getItem('launchOfferModalClosed');
    if (isClosed) return;

    const timer = setTimeout(() => setIsOpen(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  const close = () => {
    setIsOpen(false);
    sessionStorage.setItem('launchOfferModalClosed', 'true');
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={close}
            className="fixed inset-0 z-[9998] bg-ink/60 backdrop-blur-sm"
          />

          <div className="fixed inset-0 z-[9999] flex items-center justify-center p-6 pointer-events-none">
            <motion.div
              initial={{ opacity: 0, scale: 0.96, y: 16 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.96, y: 10 }}
              transition={{ duration: 0.25 }}
              className="pointer-events-auto w-full max-w-sm rounded-card bg-white dark:bg-dark-surface border border-line dark:border-dark-line shadow-2xl relative text-center p-8 pt-10"
            >
              <button
                onClick={close}
                aria-label="Close"
                className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center text-ink-soft dark:text-dark-ink-soft hover:bg-surface-alt dark:hover:bg-white/10 hover:text-ink dark:hover:text-dark-ink transition-colors"
              >
                <X size={18} strokeWidth={2} />
              </button>

              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-5 bg-primary-tint dark:bg-primary/10 border border-primary/25 text-primary">
                <span className="w-1.5 h-1.5 rounded-full bg-primary" />
                Launch Offer
              </span>

              <h2 className="text-7xl font-black leading-none text-primary mb-2">₹0</h2>
              <p className="text-lg font-bold text-ink dark:text-dark-ink mb-2">Commission &amp; Platform Fee</p>
              <p className="text-sm text-ink-soft dark:text-dark-ink-soft leading-relaxed">
                Drivers keep 100% of the fare. Riders pay near-zero surge.
              </p>

              <div className="flex flex-col gap-3 mt-7">
                <a
                  href="https://play.google.com/store/apps/details?id=com.elt.totowala"
                  target="_blank" rel="noopener noreferrer"
                  onClick={close}
                  className="flex items-center justify-center gap-2 w-full py-3.5 rounded-control bg-primary hover:bg-primary-dark text-white font-semibold text-sm transition-colors"
                >
                  <User size={17} strokeWidth={2.5} />
                  Download Rider App
                </a>

                <a
                  href="https://play.google.com/store/apps/details?id=com.elt.totowalafordrivers"
                  target="_blank" rel="noopener noreferrer"
                  onClick={close}
                  className="flex items-center justify-center gap-2 w-full py-3.5 rounded-control bg-teal-dark hover:bg-teal text-white font-semibold text-sm transition-colors"
                >
                  <Car size={17} strokeWidth={2.5} />
                  Download Driver App
                </a>
              </div>
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  );
};

export default LaunchOfferModal;
